import { Size } from '@Components/designConstants';
import { Dropdown } from '@Components/Dropdown';
import { FILTER_ALL } from '../alexa-visibility-constants';

interface QueryMultiSelectProps {
  options: string[];
  // The specific queries chosen; empty means every query.
  selected: string[];
  onChange: (selected: string[]) => void;
}

// A multi-select of queries with "All queries" at the top. Choosing "All queries" clears any
// specific queries; choosing a specific query while it is selected replaces it; clearing
// everything goes back to all queries.
export const QueryMultiSelect = ({ options, selected, onChange }: QueryMultiSelectProps) => (
  <Dropdown
    size={Size.LG}
    searchable
    multiSelect
    placeholder='All queries'
    value={selected.length === 0 ? [FILTER_ALL] : selected}
    options={[
      { label: 'All queries', value: FILTER_ALL },
      ...options.map(query => ({ label: query, value: query }))
    ]}
    onChange={values => {
      const choseAll = values.includes(FILTER_ALL) && selected.length > 0;
      onChange(choseAll ? [] : values.filter(value => value !== FILTER_ALL));
    }}
  />
);
